import React, {useEffect, useReducer, useRef, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import ReactPlayer from "react-player";
import {PreviewVideo} from "../../../Interfaces/PreviewData";
import Loader from "../../Common/Loader";
import * as Sentry from "@sentry/react";
import {empty640x360} from "../../../Utils/embedImages";
import PreviewCountdownCircleTimer from "../../Common/PreviewCountdownCircleTimer";
import {PREVIEW_DEFAULT_VOLUME, setIsPreviewPlaying, setPreviewVolume} from "../../../store/makerDataSlice";
import {canGetPreviewStatus} from "../../../Api/getPreviewStatus";
import PreviewTimeline from "../../../ComponentsForked/PreviewTimeline";
import {Button, Form} from "react-bootstrap";
import ym from "react-yandex-metrika";
import {ErrorBoundary} from "../../Common/ErrorBoundary";

var isTouchDevice = require('is-touch-device');

interface PreviewProps {
    openPopupHowGetDiscount: () => void,
    onGotoSlidesTab: () => void
}

const Preview: React.FC<PreviewProps> = ({
                                             openPopupHowGetDiscount,
                                             onGotoSlidesTab
                                         }) => {

    const DEBUG_PREVIEW_CONSOLE_LOG = true;

    const [previewAllPositionMilliSeconds, setPreviewAllPositionMilliSeconds] = useState<number>(0);
    const [previewAllDurationSeconds, setPreviewAllDurationSeconds] = useState<number>(0);
    const [isChunkReadyToPlay, setIsChunkReadyToPlay] = useState<boolean>(false);
    const [isFinalVideoInPlayer, setIsFinalVideoInPlayer] = useState<boolean>(false);
    const [isFirstVideoInPlayer, setIsFirstVideoInPlayer] = useState<boolean | null>(null);
    // чтобы установить state внутри setTimeout, useState не подходит, поэтому используем useRef как лайфхак для хранения данных
    // https://felixgerschau.com/react-hooks-settimeout/
    const isVideoEndedTimeoutRef = useRef(null as null| boolean);
    const [, forceUpdate] = useReducer(x => x + 1, 0);

    const [isPreviewLoop, setIsPreviewLoop] = useState<boolean>(false);

    const [currentChunkIndex, setCurrentChunkIndex] = useState<number | null>(null);
    const [currentVideoUrl, setCurrentVideoUrl] = useState<string>('');
    // URL видео без #t=xxx нужно для onVideoError, чтобы если он возник - добавить GET параметр к URL видео video.mp4?tmp=xxx#t=yyy
    const [currentVideoUrlWithoutMediaFragment, setCurrentVideoUrlWithoutMediaFragment] = useState<string>('');
    // было ли событие onVideoError, чтобы попробовать загрузить видео ещё ТОЛЬКО один раз, чтобы бесконечно это не делать
    const [hasVideoError, setHasVideoError] = useState<boolean>(false);

    const [stubHeightValue, setStubHeightValue] = useState<number>(0);

    const stubHeightRef = useRef(null as null | HTMLImageElement);
    const previewPlayerRef = useRef<ReactPlayer>(null);

    const previewData = useAppSelector(state => state.makerData.previewData)
    const previewVolume = useAppSelector(state => state.makerData.previewVolume)
    const isPreviewPlaying = useAppSelector(state => state.makerData.isPreviewPlaying)
    const makerData = useAppSelector(state => state.makerData)
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (previewData === null || typeof previewData === 'undefined') {
            setPreviewAllPositionMilliSeconds(0);
            setPreviewAllDurationSeconds(0);
            // dispatch(setIsPreviewPlaying(true));
            setIsPreviewLoop(false);
            setCurrentChunkIndex(null);
            setIsChunkReadyToPlay(false);
            setIsFinalVideoInPlayer(false);
            setIsFirstVideoInPlayer(null);
            setCurrentVideoUrl('');
            setCurrentVideoUrlWithoutMediaFragment('');
            setHasVideoError(false);
        } else {
            // устанавливаем общую продолжительность видео
            setPreviewAllDurationSeconds(previewData.mainVideo.durationSeconds * 1000);

            // Смотрим все chunk'и (начиная с последнего).
            // Если какой-то готов - то это его видео подставляем в плеер
            for (var chunkIndex = previewData.chunks.length - 1; chunkIndex >= 0; chunkIndex--) {
                if (previewData.chunks[chunkIndex].isReady && (
                    currentChunkIndex === null ||
                    chunkIndex > currentChunkIndex ||
                    (chunkIndex === currentChunkIndex && chunkIndex === previewData.chunks.length - 1) // когда все chunk'и готовы, но мы продолжаем ждать, когда mainVideo.isReady станет true
                )) {


                    if (isFirstVideoInPlayer === true) {
                        setIsFirstVideoInPlayer(false);
                    }
                    if (isFirstVideoInPlayer === null) {
                        setIsFirstVideoInPlayer(true);
                    }

                    if (DEBUG_PREVIEW_CONSOLE_LOG) {
                        console.log('debug: chunk data 1')
                        console.log('debug:', isFirstVideoInPlayer, isPreviewPlaying, isChunkReadyToPlay, isVideoEndedTimeoutRef.current);
                    }

                    if ((isFirstVideoInPlayer === null || !isPreviewPlaying || !isChunkReadyToPlay) && isVideoEndedTimeoutRef.current === null) {
                        if (DEBUG_PREVIEW_CONSOLE_LOG) {
                            console.log('debug: chunk data')
                            console.log('debug:', isFirstVideoInPlayer, isPreviewPlaying, isChunkReadyToPlay, isVideoEndedTimeoutRef.current);
                            console.log('debug:', chunkIndex);
                        }
                        setIsChunkReadyToPlay(true);
                        setCurrentChunkIndex(chunkIndex);
                        // если готов последний chunk - то это играет финальное видео
                        if (chunkIndex === previewData.chunks.length - 1 && previewData?.mainVideo?.isReady === true) {
                            if (DEBUG_PREVIEW_CONSOLE_LOG) {
                                console.log('debug: setCurrentVideoUrl: ' + previewData.mainVideo.url);
                            }
                            setCurrentVideoUrl(previewData.mainVideo.url + '#t=' + Number(previewAllPositionMilliSeconds / 1000).toFixed(2));
                            setCurrentVideoUrlWithoutMediaFragment(previewData.mainVideo.url);
                            setHasVideoError(false);
                            setIsFinalVideoInPlayer(true);
                            setIsPreviewLoop(true);
                            ym('reachGoal', 'previewReady');
                        } else {
                            if (DEBUG_PREVIEW_CONSOLE_LOG) {
                                console.log('debug: setCurrentVideoUrl: ' + previewData.chunks[chunkIndex].url);
                            }
                            setCurrentVideoUrl(previewData.chunks[chunkIndex].url + '#t=' + Number(previewAllPositionMilliSeconds / 1000).toFixed(2));
                            setCurrentVideoUrlWithoutMediaFragment(previewData.chunks[chunkIndex].url);
                            setHasVideoError(false);
                        }
                    }

                    break;
                }
            }
        }

        if (previewData?.mainVideo?.isReady === true) {
            canGetPreviewStatus.value = false;
        }
    }, [previewData])

    useEffect(() => {
        if (DEBUG_PREVIEW_CONSOLE_LOG) {
            console.log('debug: useEffect isVideoEndedTimeoutRef.current: ' + isVideoEndedTimeoutRef.current);
        }

        if (isVideoEndedTimeoutRef.current === false) {
            if (DEBUG_PREVIEW_CONSOLE_LOG) {
                console.log('debug: timeout ended');
                console.log('debug:', isFirstVideoInPlayer, isPreviewPlaying, isChunkReadyToPlay, isVideoEndedTimeoutRef.current);
            }
            if (previewData !== null) {
                // Смотрим все chunk'и (начиная с последнего).
                // Если какой-то готов - то это его видео подставляем в плеер
                for (var chunkIndex = previewData.chunks.length - 1; chunkIndex >= 0; chunkIndex--) {
                    if (DEBUG_PREVIEW_CONSOLE_LOG) {
                        console.log('debug:', chunkIndex, currentChunkIndex);
                    }
                    if (previewData.chunks[chunkIndex].isReady && (
                        currentChunkIndex === null ||
                        chunkIndex > currentChunkIndex ||
                        (chunkIndex === currentChunkIndex && chunkIndex === previewData.chunks.length - 1) // когда все chunk'и готовы, но мы продолжаем ждать, когда mainVideo.isReady станет true
                    )) {
                        setIsChunkReadyToPlay(true);
                        setCurrentChunkIndex(chunkIndex);

                        if (DEBUG_PREVIEW_CONSOLE_LOG) {
                            console.log('debug: setCurrentChunkIndex: ' + chunkIndex);
                        }

                        // если готов последний chunk - то это играет финальное видео
                        if (chunkIndex === previewData.chunks.length - 1 && previewData?.mainVideo?.isReady === true) {
                            if (DEBUG_PREVIEW_CONSOLE_LOG) {
                                console.log('debug: setCurrentVideoUrl: ' + previewData.mainVideo.url);
                            }
                            setCurrentVideoUrl(previewData.mainVideo.url + '#t=' + Number(previewAllPositionMilliSeconds / 1000).toFixed(2));
                            setCurrentVideoUrlWithoutMediaFragment(previewData.mainVideo.url);
                            setHasVideoError(false);
                            setIsFinalVideoInPlayer(true);
                            setIsPreviewLoop(true);
                            ym('reachGoal', 'previewReady');
                        } else {
                            if (DEBUG_PREVIEW_CONSOLE_LOG) {
                                console.log('debug: setCurrentVideoUrl: ' + previewData.chunks[chunkIndex].url);
                            }
                            setCurrentVideoUrl(previewData.chunks[chunkIndex].url + '#t=' + Number(previewAllPositionMilliSeconds / 1000).toFixed(2));
                            setCurrentVideoUrlWithoutMediaFragment(previewData.chunks[chunkIndex].url);
                            setHasVideoError(false);
                        }

                        break;
                    }
                }
            }

            isVideoEndedTimeoutRef.current = null;
        }

    }, [isVideoEndedTimeoutRef.current])

    /**
     * Возвращает следующий chunk, чью генерацию мы ожидаем и показываем stub
     * если ещё не было chunk'ов - возвращаем первый (ждём, когда он будет готов, а пока показываем stub)
     * если уже были chunk'и - то возвращаем следующий после currentChunkIndex
     */
    const getWaitingChunk = (): PreviewVideo | null => {
        //currentChunkIndex !== null ? previewData.chunks[currentChunkIndex] : null
        if (currentChunkIndex === null) {
            if (typeof previewData?.chunks[0] !== 'undefined') {
                return previewData?.chunks[0];
            }
        } else {
            if (typeof previewData?.chunks[currentChunkIndex + 1] !== 'undefined') {
                return previewData?.chunks[currentChunkIndex + 1];
            }
        }

        return null;
    }

    /**
     * Возвращает общую продолжительность готовых chunk'ов в мс
     */
    const getReadyChunksDuration = () => {
        let duration = 0;
        if (previewData !== null && typeof previewData !== 'undefined') {
            for (var chunkIndex = previewData.chunks.length - 1; chunkIndex >= 0; chunkIndex--) {
                // цикл от последнего к первому, как только встречаем готовый chunk -
                // считаем, что все, что перед ним тоже готовы и суммируем их duration
                if (!previewData.chunks[chunkIndex].isReady && duration === 0) {
                    continue;
                }
                if (currentChunkIndex !== null && chunkIndex > currentChunkIndex) {
                    continue;
                }

                duration += previewData.chunks[chunkIndex].durationSeconds;
            }
        }
        return duration * 1000;
    }

    const onVideoEnded = () => {
        // если это НЕ финальное видео остановилось - нужно показать preloader
        if (!isFinalVideoInPlayer) {
            setIsChunkReadyToPlay(false);

            setPreviewAllPositionMilliSeconds(getReadyChunksDuration());

            if (DEBUG_PREVIEW_CONSOLE_LOG) {
                console.log('debug: onVideoEnded')
                console.log('debug:', isFirstVideoInPlayer, isPreviewPlaying, isChunkReadyToPlay, isVideoEndedTimeoutRef.current);
                console.log('debug:', previewAllPositionMilliSeconds, getReadyChunksDuration());
            }

            isVideoEndedTimeoutRef.current = true;

            setTimeout(
                () => {
                    if (DEBUG_PREVIEW_CONSOLE_LOG) {
                        console.log('debug: timeout triggered')
                        console.log('debug: isVideoEndedTimeoutRef.current: ' + isVideoEndedTimeoutRef.current)
                    }
                    /**
                     * Используем хак с установкой значения в useRef + отслеживание этого значение в useEffect (выше)
                     * т.к. внутри setTimeout нельзя изменить значение useState переменных
                     */
                    isVideoEndedTimeoutRef.current = false;
                    forceUpdate();
                },
                3000
            )
        }
    }

    const onVideoError = (error: any) => {
        if (!hasVideoError) {
            const retryVideoUrl = currentVideoUrlWithoutMediaFragment + '?r=' + Math.random() + '#t=' + Number(previewAllPositionMilliSeconds / 1000).toFixed(2);
            if (DEBUG_PREVIEW_CONSOLE_LOG) {
                console.log('debug: onVideoError');
            }
            dispatch(setIsPreviewPlaying(false));
            setTimeout(() => {
                setCurrentVideoUrl(retryVideoUrl);
            }, 700);
        } else {
            // Если ошибка возникает второй раз, после добавления ?r=xxx
            Sentry.captureException(
                new Error('Preview video error.'),
                {
                    extra: {error: error, failedVideoUrl: currentVideoUrl, currentVideoUrl: currentVideoUrl}
                }
            );
        }
        setHasVideoError(true);
    }

    const onPlay = () => {
        setIsFirstVideoInPlayer(false);
    }

    const onVideoReady = () => {
        if (makerData.currentTab === 'payment') {
            if (currentVideoUrl != '' && isFirstVideoInPlayer) {
                // включаем play вручную, т.к. на iPhone'ах баг - не работает autoplay при определенных условиях
                if (previewPlayerRef !== null) {
                    const promise = previewPlayerRef!.current!.getInternalPlayer().play();

                    if (promise !== undefined) {
                        // @ts-ignore
                        promise.then(_ => {
                            // console.log('play - ok')
                            dispatch(setIsPreviewPlaying(true));
                            // @ts-ignore
                        }).catch(error => {
                            // console.log('play - error')
                            if (DEBUG_PREVIEW_CONSOLE_LOG) {
                                console.log('debug: onVideoReady');
                            }
                            dispatch(setIsPreviewPlaying(false));
                        });
                    }
                }

                // Когда видео готово к воспроизведению, если isPreviewPlaying=true - то оно должно начать
                // проигрываться автоматически, но на Iphone это не происходит.
                // Здесь мы проверяем началось ли воспроизведение, если нет то ставим isPreviewPlaying=false
                // чтобы у пользователя показалась кнопка Play и он сам её нажал
                setTimeout(() => {
                    // @ts-ignore
                    // console.log(previewPlayerRef?.current?.getInternalPlayer()?.currentTime);
                    // @ts-ignore
                    // console.log(!previewPlayerRef?.current?.getInternalPlayer()?.paused);
                    // @ts-ignore
                    // console.log(!previewPlayerRef?.current?.getInternalPlayer()?.ended);
                    // @ts-ignore
                    // console.log(previewPlayerRef?.current?.getInternalPlayer()?.readyState);

                    // https://stackoverflow.com/questions/43570460/html5-video-autoplay-on-iphone
                    const tmpIsPlaying = !!(
                        // @ts-ignore
                        previewPlayerRef?.current?.getInternalPlayer()?.currentTime > 0 &&
                        // @ts-ignore
                        !previewPlayerRef?.current?.getInternalPlayer()?.paused &&
                        // @ts-ignore
                        !previewPlayerRef?.current?.getInternalPlayer()?.ended &&
                        // @ts-ignore
                        previewPlayerRef?.current?.getInternalPlayer()?.readyState > 2
                    );

                    if (!tmpIsPlaying) {
                        if (DEBUG_PREVIEW_CONSOLE_LOG) {
                            console.log('debug: onVideoReady, tmpIsPlaying=false');
                            console.log('debug: setIsPreviewPlaying(false)');
                        }
                        dispatch(setIsPreviewPlaying(false));
                    }

                }, 1000);
            }
        }
    }

    /* Вычисляем высоту заглушки, чтобы подставить в высоту контейнера для видео
        т.к. когда переключаемся на следующее видео, весь блок на секунду моргает и сокращается по высоте до 0
        в общем, это нужно, чтобы не дёргалось во время переключения на следующее видео
     */
    const setStubHeight = () => {
        if (stubHeightRef.current && stubHeightRef.current.clientHeight) {
            const height = stubHeightRef.current.clientHeight;
            setStubHeightValue(height);
        }
    }
    useEffect(() => {
        setStubHeight();
    })
    useEffect(() => {
        window.addEventListener('resize', setStubHeight);

        // Cleanup function
        // Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', setStubHeight);
        }
    }, []);
    /** ---- **/

    return (
        <div className={'video-container'}>
            {previewData !== null
                ?
                (
                    <div>
                        <div
                            className={'video-container-2'} style={{height: stubHeightValue}}
                            onClick={() => {
                                dispatch(setIsPreviewPlaying(!isPreviewPlaying));
                            }}>
                            <ReactPlayer
                                ref={previewPlayerRef}
                                url={currentVideoUrl}
                                key={'preview-player'}
                                volume={previewVolume / 100}
                                muted={false}
                                playing={isPreviewPlaying}
                                loop={isPreviewLoop}
                                width={'100%'}
                                height={'100%'}
                                controls={false}
                                playsinline={true}
                                progressInterval={50}
                                onEnded={onVideoEnded}
                                onError={onVideoError}
                                onProgress={(state) => {
                                    setPreviewAllPositionMilliSeconds(
                                        state.playedSeconds * 1000
                                    );
                                }}
                                onReady={onVideoReady}
                                onPlay={onPlay}
                                config={{
                                    file: {
                                        attributes: {
                                            preload: 'auto',
                                            // poster показываем только если воспроизведение не началось, т.к.
                                            // при смене chunk'ов если есть poster - он моргает, видно его при переключении chunk'ов
                                            poster: previewData?.coverImageUrl !== false && previewAllPositionMilliSeconds === 0 ? previewData?.coverImageUrl : ''
                                        }
                                    }
                                }}
                            />
                            <div className={'stub-height'}>
                                <img
                                    src={empty640x360}
                                    ref={stubHeightRef}
                                    onLoad={() => {
                                        setStubHeight();
                                    }}
                                />
                            </div>

                            {
                                !isChunkReadyToPlay // если ждём пока chunk будет готов
                                && (previewAllPositionMilliSeconds >= getReadyChunksDuration()) // и не перемотали немного назад, чтобы посмотреть пока предыдущие chunk'и
                                    ? // показываем заглушку
                                    (
                                        <div className={'stub-generation-in-progress'}>
                                            {
                                                currentChunkIndex === null ?
                                                    (
                                                        <video
                                                            src={'https://files5-cdn.slide-life.ru/sl/vk/video/scenes/preview-loading-bg.mp4'}
                                                            autoPlay={true}
                                                            muted={true}
                                                            controls={false}
                                                            loop={true}/>
                                                    ) : ''
                                            }
                                            <div className={'inner'}>
                                                <h4 className={'text-1'}>Генерируем видео</h4>
                                                <p className={'text-2'}>Воспроизведение {currentChunkIndex === null ? 'начнётся' : 'продолжится'} через</p>
                                                <div className={'timer-wrapper'}>
                                                    <PreviewCountdownCircleTimer
                                                        waitingChunk={getWaitingChunk()}
                                                        animationDuration={8}
                                                        size={Math.floor(stubHeightValue / 2)}
                                                        strokeWidth={12}
                                                    />
                                                </div>
                                                {
                                                    makerData.vkLaunchParams?.vk_app_id ? '' :
                                                        <div className={'text-vk'}>
                                                            <span
                                                                onClick={() => {
                                                                    openPopupHowGetDiscount()
                                                                }}
                                                            >
                                                                Вступайте в нашу группу <i className="fab fa-vk"></i> и получите скидку 25%
                                                            </span>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    ) : ''
                            }

                            {
                                isChunkReadyToPlay && !isPreviewPlaying ?
                                    <div
                                        className="play-btn-overlay"
                                        onClick={() => {
                                            dispatch(setIsPreviewPlaying(!isPreviewPlaying));
                                        }}
                                    >
                                        <i className={`fa ${isPreviewPlaying ? 'fa-pause' : 'fa-play'}`}></i>
                                    </div> : ''
                            }
                        </div>
                        <div className={'controls'}>
                            <div
                                className="play-btn"
                                onClick={() => {
                                    dispatch(setIsPreviewPlaying(!isPreviewPlaying));
                                }}
                            >
                                <i className={`fa ${isPreviewPlaying ? 'fa-pause' : 'fa-play'}`}></i>
                            </div>
                            <div className={'time-label'}>
                                {new Date(previewAllPositionMilliSeconds).toISOString().substr(14, 5)}
                                &nbsp;/&nbsp;
                                {new Date(previewAllDurationSeconds).toISOString().substr(14, 5)}
                            </div>
                            <div className={'stretch'}></div>
                            {
                                !isTouchDevice() ?
                                    <div className={'volume-control'}>
                                        <div
                                            className="volume-btn"
                                            onClick={() => {
                                                if (previewVolume > 0) {
                                                    dispatch(setPreviewVolume(0));
                                                } else {
                                                    dispatch(setPreviewVolume(PREVIEW_DEFAULT_VOLUME));
                                                }
                                            }}
                                        >
                                            <i className={`fa ${previewVolume > 0 ? 'fa-volume-low' : 'fa-volume-xmark'}`}></i>
                                        </div>
                                        <Form.Range
                                            className={'volume-range styled-slider slider-progress'}
                                            // @ts-ignore
                                            style={{'--value': previewVolume, '--min': 0, '--max': 100}}
                                            min={0}
                                            max={100}
                                            step={10}
                                            value={previewVolume}
                                            onInput={(e) => {
                                                dispatch(setPreviewVolume(parseInt(e.currentTarget.value)));
                                            }}
                                        />
                                    </div>
                                    : ''
                            }
                        </div>

                        <div style={{width: '100%', height: '50'}}>
                            <ErrorBoundary
                                place={'Preview-PreviewTimeline'}
                                key={'preview-timeline'}>
                                <PreviewTimeline
                                    min={0}
                                    max={previewAllDurationSeconds}
                                    defaultValue={[0, getReadyChunksDuration()]}
                                    value={[previewAllPositionMilliSeconds, getReadyChunksDuration()]}
                                    className={`horizontal-slider ${isFinalVideoInPlayer ? 'all-chunks-ready' : ''}`}
                                    thumbClassName="thumb"
                                    trackClassName="track"
                                    // @ts-ignore
                                    renderTrack={(props, state) => {
                                        if (state.index === 2) {
                                            return <div {...props} >
                                                <div className="progress progress-striped active">
                                                    <div role="progressbar"
                                                         className="progress-bar progress-bar-sl"></div>
                                                </div>
                                            </div>
                                        }
                                        return <div {...props} />
                                    }}
                                    // @ts-ignore
                                    onChange={(value, index) => {
                                        previewPlayerRef.current?.seekTo(value[0] / 1000);
                                    }}
                                />
                            </ErrorBoundary>
                        </div>
                        <Button
                            className={'btn-back-to-slides'}
                            variant="btn-sm btn-light2"
                            onClick={() => {
                                dispatch(setIsPreviewPlaying(false));
                                onGotoSlidesTab();
                            }}
                        >
                            <i className={'fa fa-arrow-left'}></i>
                            {
                                makerData.savedProjectPaymentDone ?
                                    (<span> Сделать другое видео</span>) :
                                    (<span> Вернуться к редактированию</span>)
                            }
                        </Button>
                        {
                            makerData.info.length > 0 && makerData.infoC && isFinalVideoInPlayer ?
                                <div className={'info-c'}>
                                    <Button
                                        className={'info-c-btn-final'}
                                        variant="btn-sm btn-primary"
                                        onClick={() => {
                                            dispatch(setIsPreviewPlaying(false));
                                            window.open(currentVideoUrlWithoutMediaFragment, '_blank');
                                        }}
                                    >Скачать</Button>
                                    <div className={'info-c-preview-id'}>
                                        <Form.Control
                                            className={'preview-id-input'}
                                            value={makerData.previewId ? makerData.previewId : ''}
                                        />
                                        <Button
                                            variant="btn-sm btn-light"
                                            onClick={() => {
                                                // @ts-ignore
                                                document.getElementsByClassName('preview-id-input')[0].select();
                                                document.execCommand('copy');
                                            }}
                                            title={'Копировать'}
                                        ><i className={'fa fa-clipboard'}></i></Button>
                                    </div>
                                </div> : ''
                        }
                    </div>
                )
                :
                (
                    <div className={'loaderContainer'}>
                        <Loader showProgress={false}
                                isLoaded={false}
                                background={'transparent'}/>
                    </div>
                )
            }
        </div>
    )
}

export default Preview;